<!--
 * @Descripttion: 帆软报表内嵌页面
 * @Author: chenjinsheng
 * @Date: 2021-10-26 10:56:00
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-26 13:04:29
-->
<template>
    <div class="viewport-panel--page">
        <div class="sidebar">
            <sidebar-menu @node-click="handleNodeClick"></sidebar-menu>
        </div>
        <div class="content">
            <report-content :url="url"></report-content>
        </div>
    </div>
</template>

<script>
import SidebarMenu from "./components/sidebar-menu";
import ReportContent from "./components/report-content";

export default {
    name: "ViewportPanel",
    components: {
        [SidebarMenu.name]: SidebarMenu,
        [ReportContent.name]: ReportContent,
    },
    data() {
        return {
            url: "",
        };
    },
    methods: {
        handleNodeClick(url) {
            this.url = url;
        },
    },
};
</script>

<style lang="scss" scoped>
.viewport-panel--page {
    width: 100%;
    height: 100%;
    padding: 5px;
    clear: both;
    .sidebar {
        float: left;
        width: 225px;
        height: 100%;
        background: #fff;
    }
    .content {
        float: left;
        width: calc(100% - 230px);
        height: 100%;
        margin-left: 5px;
        background: #fff;
    }
}
</style>
